import { createContext, useContext, useState, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Modal, Button } from '@getpay93/ui';
import { api } from '../lib/api';
import { qk } from './queryKeys';

interface PaywallState { openUpgrade: () => void; }
const Ctx = createContext<PaywallState | null>(null);

export function PaywallProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const plan = useQuery({ queryKey: qk.mePlan, queryFn: () => api.mePlan.get(), enabled: open });

  async function requestUpgrade() {
    try { await api.mePlan.requestUpgrade(); setSent(true); } catch { setSent(true); }
  }

  return (
    <Ctx.Provider value={{ openUpgrade: () => { setSent(false); setOpen(true); } }}>
      {children}
      {open ? (
        <Modal
          open
          onClose={() => setOpen(false)}
          title="Mejora tu plan"
          subtitle="Llegaste al límite del plan gratis"
          footer={<><Button variant="ghost" onClick={() => setOpen(false)}>Cerrar</Button>{!sent ? <Button onClick={requestUpgrade}>Solicitar upgrade</Button> : null}</>}
        >
          {sent ? (
            <p style={{ color: 'var(--text-muted)' }}>¡Listo! Recibimos tu solicitud, te contactamos pronto.</p>
          ) : (
            <p style={{ color: 'var(--text-muted)' }}>
              {plan.data ? <>Usas <strong>{plan.data.activeClients}</strong> de <strong>{plan.data.effectiveFreeLimit}</strong> cupos. Con Pro agregas clientes sin límite.</> : 'Con Pro agregas clientes sin límite.'}
            </p>
          )}
        </Modal>
      ) : null}
    </Ctx.Provider>
  );
}

export function usePaywall(): PaywallState {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('usePaywall dentro de <PaywallProvider>');
  return ctx;
}
